<template>
    <div class="offer__wrapper">
        <div class="offer__container">
            <div
                v-if="isLoading"
                class="spinner-container--terminal"
            >
                <SpinnerBars/>
            </div>
            <SpecialGrid
                v-else-if="hasAnyEvent"
                @eventClick="onEventClick"
                :isResults="false"
                :events="eventsFilteredByDate"
                :expandedEventId="expandedEventId"
                :selections="selections"
                :gridStartOffset="gridStartOffset"
                @oddClick="onOddClick"
            />
            <div
                v-else
                class="empty-state__specials--terminal"
            >
                <Illustration large image="/static/img/illustrations/terminal/offer__empty-state--dark.svg"/>
                <div class="empty-state__specials-copy">
                    {{ $t('There are currently no bets available') }}
                </div>
                <div class="flex__justify-center py-4">
                    <div
                        class="btn btn__secondary btn__icon--left"
                        @click="goToAllOffer"
                    >
                        <i class="icon icon-chevron_left btn__icon" />
                        {{ $t('all offer') | upperCase }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { routeNames } from 'src/app/router';
    import { mapGetters, mapActions } from 'vuex';
    import SpecialGrid from '@src/terminal/app/modules/shared/special/SpecialGrid.vue';
    import { errorGuard } from 'src/app/utils';
    import { GRID_START_OFFSET } from './constants';

    export default {
        name: 'SpecialOfferContainer',
        data() {
            return {
                isDetailLoading: false,
                gridStartOffset: GRID_START_OFFSET,
            };
        },
        watch: {
            expandedEventId() {
                this.performActionAfterExpandedEvent();
            },
            isInitialFetchFinished(newValue) {
                if (newValue) {
                    this.performActionAfterExpandedEvent();
                }
            }
        },
        computed: {
            ...mapGetters('data/specialOffer', [
                'isLoading',
                'isInitialFetchFinished',
            ]),
            ...mapGetters('ui/special', [
                'eventsFilteredByDate',
            ]),
            ...mapGetters('ui/special', [
                'expandedEventId',
            ]),
            ...mapGetters('ui/sportOffer/betSlip', [
                'selections',
            ]),
            hasAnyEvent() {
                return this.eventsFilteredByDate.length > 0;
            },
        },
        methods: {
            ...mapActions('data/specialOffer', [
                'fetchSpecialDetail',
            ]),
            ...mapActions('ui/special', [
                'toggleExpandedEvent',
            ]),
            ...mapActions('ui/sportOffer/betSlip', [
                'toggleAddRemoveSelection',
            ]),
            async performActionAfterExpandedEvent() {
                const eventId = this.expandedEventId;
                if (eventId) {
                    this.isDetailLoading = true;
                    await errorGuard({
                        action: async () => {
                            await this.fetchSpecialDetail(eventId);
                        },
                    });
                    this.isDetailLoading = false;
                }
            },
            onEventClick(eventId) {
                this.toggleExpandedEvent(eventId);
            },
            onOddClick(selection) {
                this.toggleAddRemoveSelection(selection);
            },
            goToAllOffer() {
                this.$router.push({ name: routeNames.landing });
            },
        },
        components: {
            SpecialGrid,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/specialOffer/content/SpecialOfferContainer.vue